<template>
  <div>
    <el-form class="demo-form-inline searchForm"
             ref="filter"
             :model="filter"
             :label-width="config.label=='85px'"
             :inline="true">
      <el-form-item v-for="(item,index) in config.filterCondition"
                    :key="index"
                    :label="item.label||''"
                    style="margin-right:40px;">
        <el-input v-if="item.type == 'input'"
                  :style="{'width':config.itemWidth||'160px'}"
                  :value="filter[item.key]"
                  :maxlength="item.maxlength"
                  @keypress.enter="filterSearch"
                  @input="regularText($event,item.regular,item.key,item)"
                  :placeholder="item.placeholder||`请输入${item.label||''}`"></el-input>
        <el-input v-if="item.type == 'numInput'"
                  onkeyup="this.value=this.value.replace(/[^0-9-]+/,'');"
                  :style="{'width':config.itemWidth||'160px'}"
                  :value="filter[item.key]"
                  :maxlength="item.maxlength"
                  @keypress.enter="filterSearch"
                  @input="regularNum($event,item.regular,item.key,item)"
                  :placeholder="item.placeholder||`请输入${item.label||''}`"></el-input>
        <el-date-picker v-else-if="item.type == 'dateRange'"
                        v-model="filter[item.key]"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeDateRange(item.key)"
                        @blur="changeDateRange(item.key)"
                        :picker-options="datePickerOptions"></el-date-picker>
        <el-autocomplete v-else-if="item.type == 'autocomplete'"
                         :style="{'width':config.itemWidth||'160px'}"
                         :placeholder="item.placeholder||`请输入${item.label||''}`"
                         v-model="interim[`_${item.key}`]"
                         @focus="setQueryObj(item.key,item.queryObj)"
                         @keypress.enter="filterSearch"
                         @input="setQueryKey"
                         :fetch-suggestions="querySearchAsync"
                         @select="handleSelect"></el-autocomplete>
        <el-cascader v-else-if="item.type == 'cascader'"
                     filterable
                     :change-on-select="item.selectAll||false"
                     :style="{'width':config.itemWidth||'160px'}"
                     :placeholder="item.placeholder||`请选择${item.label||''}`"
                     :value="item.value"
                     :debounce="2000"
                     :show-all-levels="false"
                     @keypress.enter="filterSearch"
                     :options="interim[`_${item.key}Options`]||[]"
                     @change="cascaderSelect($event,item.key)"></el-cascader>
        <el-date-picker v-else-if="item.type == 'statrDate'"
                        type="date"
                        value-format="yyyy-MM-dd 00:00:00"
                        v-model="filter[item.key]"
                        @keypress.enter="filterSearch"
                        :style="{'width':config.itemWidth||'160px'}"
                        :placeholder="item.placeholder||`请选择${item.label||''}`"></el-date-picker>
        <el-date-picker v-else-if="item.type == 'endDate'"
                        type="date"
                        value-format="yyyy-MM-dd 23:59:59"
                        v-model="filter[item.key]"
                        @keypress.enter="filterSearch"
                        :style="{'width':config.itemWidth||'160px'}"
                        :placeholder="item.placeholder||`请选择${item.label||''}`"></el-date-picker>
        <el-checkbox v-model="filter[item.key]"
                     v-else-if="item.type == 'checkBox'"></el-checkbox>
        <el-select v-else-if="item.type == 'select'"
                   v-model="filter[item.key]"
                   :multiple="item.multiple || false"
                   :style="{'width':config.itemWidth||'160px'}"
                   clearable
                   @keypress.enter="filterSearch"
                   :placeholder="item.placeholder||`请选择${item.label||''}`">
          <el-option v-for="itm in item.options"
                     :key="itm.value"
                     :label="itm.label"
                     :value="itm.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="莫名其妙的渲染bug"
                    v-show="false">
        <el-cascader :style="{'width':config.itemWidth||'160px'}"
                     :options="[]"
                     v-model="bugOptions"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button class="search-btn"
                   @click="filterSearch">查询</el-button>
        <!-- <el-button type="primary" @click="$emit('export')">导出</el-button> -->
      </el-form-item>
      <slot />
    </el-form>
    <slot />
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="currentPage"
                   :page-sizes="[25, 50, 75, 100]"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="pagination.totalCount"></el-pagination>
  </div>

</template>

<script>
export default {
  name: "listfilter",
  props: ["config", "url", "pagination"],
  data () {
    return {
      filter: {},
      interim: {}, // 临时的，区分filter的数据，避免混淆
      // type为autocomplete搜索时对应的obj
      querySearchObj: {
        key: "", // filterKey
        api: "", // 对应的api
        func: "", // 对应的接口方法名
        resList: [], // 接口返回的数据
        datePickerOptions: []
      },
      bugOptions: [],
      currentPage: 1
    };
  },
  created () {
    this.init();
    this.initModel();
  },
  mounted () {    this.filterSearch()
  },

  computed: {
    data () { }
  },
  methods: {
    changeDateRange (key) {
      this.filter = this.$methods.deepCopy(this.filter);
      if (this.filter[key]) {
        this.filter[key] = [
          this.$methods.formatDate(
            new Date(this.filter[key][0]),
            "yyyy-MM-dd 00:00:00"
          ),
          this.$methods.formatDate(
            new Date(this.filter[key][1]),
            "yyyy-MM-dd 23:59:59"
          )
        ];
      } else {
        this.filter[key] = ["", ""];
      }
    },
    regularNum (e, regular = "", key, item) {
      let eValue = e.target.value;
      eValue = eValue.replace(/[^0-9-]+/, "");
      this.filter[key] = eValue;
    },
    regularText (e, regular = "", key, item) {
      e.target.value = e.target.value.replace(regular, "");
      this.filter[key] = e.target.value;
    },
    // autocomplete
    setQueryObj (key, obj) {
      this.querySearchObj = { key, ...obj };
      let { api = "", func = "", searchKey = "key" } = obj;
      let value = this.interim[searchKey] || "";
      this.$api[api][func]({ [searchKey]: value }).then(res => {
        this.querySearchObj.resList = res;
      });
    },
    // autocomplete
    setQueryKey (value) {
      let { api = "", func = "", searchKey = "key" } = this.querySearchObj;
      this.interim[searchKey] = value;
      this.$api[api][func]({ [searchKey]: value }).then(res => {
        this.querySearchObj.resList = res;
      });
    },
    // autocomplete
    querySearchAsync (queryString, cb) {
      let list = this.querySearchObj.resList || [];
      cb(list);
    },
    // autocomplete
    handleSelect (item) {
      let { id } = item;
      let { key } = this.querySearchObj;
      this.filter[key] = id;
    },
    // cascader
    cascaderSelect (arrayValue, key) {
      this.filter[key] = [...arrayValue];
    },
    choiceGoods (arrayValue) {
      let { goodsKey } = this.interim;
      this.filter[goodsKey] = arrayValue;
    },
    choiceService (arrayValue) {
      let { serviceKey } = this.interim;
      this.filter[serviceKey] = arrayValue;
    },
    init () {
      let { filterCondition } = this.$props.config;
      filterCondition.map(item => {
        if (item.type == "cascader") {
          if (item.queryObj) {
            let { api, func } = item.queryObj;

            this.$api[api][func]().then(res => {
              this.interim[`_${item.key}Options`] = res;
              this.interim[`_${item.key}`] = [];
              this.bugOptions = []; //解决莫名奇妙的渲染bug
            });
          }
        } else if (item.type == "goods") {
          this.interim.goodsKey = item.key;
        } else if (item.type == "service") {
          this.interim.serviceKey = item.key;
        }
      });
    },
    //初始化有默认值的item
    initModel () {
      this.$props.config.filterCondition.forEach(item => {
        let { type, value, key } = item;
        if (
          type == "input" ||
          type == "dateRange" ||
          type == "select" ||
          type == "cascader" ||
          type == "checkBox"
        ) {
          if (value != undefined) {
            this.interim[key] = value;
            this.interim = { ...this.interim };
            this.filter[key] = value;
            this.filter = this.$methods.deepCopy(this.filter);
          }
        }
      });
    },
    //查询
    filterSearch () {
      let self = this
      if (!this.filter.maxResultCount) {
        this.filter.maxResultCount = 25;
      }
      this.currentPage = 1
      let { ...obj } = this.filter;
      $http.GET({
        url: this.$store.state.apiUrl + this.url,
        params: obj,
        success (res) {
          self.pagination.totalCount = res.totalCount
          self.$emit("search", res);
        },
        fail (res) {
        }
      })

    },
    //一页显示多少个
    handleSizeChange (val) {
      this.filter.maxResultCount = val;
      this.currentPage = 1
      this.filter.skipCount = 0
      let { ...obj } = this.filter;
      $http.GET({
        url: this.$store.state.apiUrl + this.url,
        params: obj,
        success (res) {
          self.pagination.totalCount = res.totalCount
          self.$emit("search", res);
        },
        fail (res) {
        }
      })

    },
    handleCurrentChange (val) {
      let skipCount = (val - 1) * this.filter.maxResultCount;
      let self = this
      this.filter.skipCount = skipCount;
      let { ...obj } = this.filter;
      $http.GET({
        url: this.$store.state.apiUrl + this.url,
        params: obj,
        success (res) {
          self.pagination.totalCount = res.totalCount
          self.$emit("search", res);
        },
        fail (res) {
        }
      })
    }
  }
};
</script>

<style scoped lang='scss'>
.filter-box {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 20px;
}
.filter-box > div {
  margin-right: 10px;
  margin-bottom: 6px;
  display: flex;
}

.filter-select {
  width: 120px;
}

.filter-input {
  width: 300px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.searchForm {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
  padding-bottom: 0;
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
